import SesamyNivoTheme from "@/components/Nivo/SesamyNivoTheme";
import { shortDateFormat } from "@/utils/numberFormat";
import dynamic from "next/dynamic";

const ResponsiveScatterPlot = dynamic(
  () =>
    import("@nivo/scatterplot").then(
      ({ ResponsiveScatterPlot }) => ResponsiveScatterPlot,
    ),
  { ssr: false },
);

const colors = [
  "#C3DF25", // lime,
  "#6EEA92", // olive,
  "#EE7B30", // orange,
  "#F3538B", // crimson,
  "#E9A8E8", // pink,
  "#6CE9FC", // baby,
] as string[];

const ScatterPlot = ({
  data,
  fullyRendered = () => {},
}: {
  data: any;
  fullyRendered?: Function;
}) => {
  return (
    <div className="aspect-[1.8/1] w-full">
      <ResponsiveScatterPlot
        layers={[
          "grid",
          "axes",
          "nodes",
          "markers",
          "mesh",
          "legends",
          "annotations",
          () => fullyRendered(true),
        ]}
        data={data}
        colors={colors}
        theme={SesamyNivoTheme}
        margin={{ top: 10, right: 30, bottom: 30, left: 30 }}
        xScale={{
          type: "time",
          format: "%Y-%m-%d",
          precision: "day",
        }}
        axisBottom={{
          format: "%b %d",
          tickValues: 8,
        }}
        xFormat="time:%Y-%m-%d"
        yScale={{
          type: "linear",
          min: 0,
          max: "auto",
        }}
        axisTop={null}
        axisRight={null}
        enableGridX={false}
        gridYValues={4}
        nodeSize={11}
        legends={[]}
        tooltip={({ node }) => {
          return (
            <div className="bg-muted row-left gap-1 rounded-2xl p-3 text-xs">
              {typeof node.formattedX === "string" && (
                <span>{shortDateFormat(node.formattedX)}:</span>
              )}
              <span>
                <strong>{node.formattedY.toLocaleString()}</strong>
              </span>
            </div>
          );
        }}
      />
    </div>
  );
};

export default ScatterPlot;
